﻿import $ from "jquery";
import "datatables.net";
import "datatables.net-rowreorder-dt";
import 'bootstrap-icons/font/bootstrap-icons.css';
import bootbox from 'bootbox';
import { showMessage } from "./main";

let dataTable: any;

$(() => {
    var currentPage = $("#currentPage").val();
    if (currentPage != "forDownloadTypeIndex") return;

    initDataTable();
    initForDownloadTypeSaveOrder();
    initForDownloadTypeDelete();

});

function initDataTable() {
    dataTable = $('#tableForDownloadType').DataTable({
        rowReorder: {
            enable: true,
            selector: 'td:first-child'
        },
        ordering: true,
        columnDefs: [
            {
                target: 0,
                visible: false,
                searchable: false
            },
            {
                target: 1,
                visible: false
            },
            { 'orderable': false, 'targets': [1, 2, 3] }
        ],
        language: {
            info: 'Strana _PAGE_ z _PAGES_',
            infoEmpty: 'Žiadne údaje',
            infoFiltered: '(filtrované z _MAX_ celkových záznamov)',
            lengthMenu: 'Zobraziť _MENU_ záznamov na stránku',
            zeroRecords: 'Nič sa nenašlo',
            search: 'Hľadať:'
        }
    });
}

function initForDownloadTypeSaveOrder() {
    $("#btnSaveOrderForDownloadType").on('click', function () {

        var data = dataTable.rows({ order: 'applied' }).data();
        var ids = [];

        data.each(function (value, index) {
            ids.push(value[1]);
        });

        var formData = {
            ids: ids
        };

        let request = $.ajax({
            type: 'Post',
            url: '/ForDownloadType/SaveOrder/',
            data: JSON.stringify(formData),
            contentType: 'application/json',
            beforeSend: function () {
                $('#spinnerContainer').removeClass('d-none');
            },
            complete: function () {
                $('#spinnerContainer').addClass('d-none');
            }
        });

        request.done(function (res) {
            if (res.error == true) {
                showMessage(res.message, "Chyba!");
            }
            else {
                showMessage(res.message);
            }
        });
        request.fail(function (jqXHR) {
            console.error(jqXHR)
        });
    });
}

function initForDownloadTypeDelete() {

    $("#tableForDownloadType tbody").off('click', '.delete');
    $('#tableForDownloadType tbody').on('click', '.delete', function () {

        let id = $(this).data("id");

        bootbox.confirm('Naozaj chcete zmazať položku?',
            function (result) {
                if (result == true) {
                    deleteForDownloadType(id);
                }
            });
    });
}

function deleteForDownloadType(id: number) {

    let request = $.ajax({
        type: 'Post',
        url: '/ForDownloadType/Delete/' + id,
        contentType: 'application/json',
        beforeSend: function () {
            $('#spinnerContainer').removeClass('d-none');
        },
        complete: function () {
            $('#spinnerContainer').addClass('d-none');
        }
    });

    request.done(function (res) {
        if (res.error == true) {
            showMessage(res.message);
        }
        else {

            var row = dataTable.row('#tr_' + id);
            row.remove().draw();
        }

    });
    request.fail(function (jqXHR) {
        console.error(jqXHR)
    });
}
